import React, { FC, useContext } from 'react';

import styled from 'styled-components';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { TXN_TYPES } from '@constants/enrollmentList/enrollmentList.constant';
import { AddOrChangeTxnFormContext } from '../context/AddOrChangeTxnProvider';
import { EnrollmentContext } from '../context/MemberMyEnrollmentProvider';
import Note from '../Note';
import AddOrChangeReasonField from './AddOrChangeReasonField';
import AddOeChangeTxnFooter from './AddOrChangeTxnFooter';
import EnrollmentTransactionTypeDropdown from './EnrolleeTransactionTypeDropdown';
import EnrollmentTxnTable from './EnrolleeTxnTable';
import EnrollmentAPTCAmounField from './EnrollmentAPTCAmounField';
import EnrollmentLastPremPaidThroughDate from './EnrollmentLastPremPaidDateField';
import EnrollmentStartDateField from './EnrollmentStartDateField';

const StyledContaner = styled.div`
    padding: 1rem;
`;

const StyledSection = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: start;
    width: 100%;
    place-items: start;
    .gi-input {
        margin: 0;
    }

    #aptcAmount {
        text-align: right;
        max-width: 80px;
    }
`;

const AddOrChangeEnrollmentTxnForm: FC = () => {
    const { isEdit } = useContext(EnrollmentContext);
    const {
        watch,
        formState: { errors },
    } = useContext(AddOrChangeTxnFormContext);
    const values = watch();

    return (
        <StyledContaner>
            <ConditionalRendering isTrue={!isEdit}>
                <StyledSection>
                    <EnrollmentStartDateField />
                    <EnrollmentAPTCAmounField />
                </StyledSection>
            </ConditionalRendering>
            <ConditionalRendering isTrue={isEdit}>
                <EnrollmentTransactionTypeDropdown />
            </ConditionalRendering>
            <EnrollmentTxnTable />
            <ConditionalRendering isTrue={errors.enrolleeEndDateUnchanged}>
                <Note message="error.member.enrollment_list.termEnrollee.endDateError" />
            </ConditionalRendering>
            <ConditionalRendering isTrue={isEdit && values.enrollmentLevelTxnType === TXN_TYPES.Term}>
                <Note message="member.enrollment_list.premiumhistory.termTransaction.note" />
            </ConditionalRendering>
            <EnrollmentLastPremPaidThroughDate />
            <AddOrChangeReasonField />
            <ConditionalRendering isTrue={!isEdit}>
                <Note message="member.enrollment_list.premiumhistory.aptcAmount.note" />
            </ConditionalRendering>
            <AddOeChangeTxnFooter />
            <ConditionalRendering isTrue={values.isTermReasonNonPayment}>
                <Note message="member.enrollment_list.premiumhistory.send834.note" />
            </ConditionalRendering>
            <ConditionalRendering isTrue={values.isTermReasonNonPayment}>
                <Note
                    message="member.enrollment_list.premiumhistory.isTermReasonNonPayment.note"
                    isNoteLabelVisible={false}
                />
            </ConditionalRendering>
        </StyledContaner>
    );
};

export default AddOrChangeEnrollmentTxnForm;
